import "bootstrap-sass/assets/javascripts/bootstrap/transition"
import "bootstrap-sass/assets/javascripts/bootstrap/tab"
import "bootstrap-sass/assets/javascripts/bootstrap/collapse"
import "bootstrap-sass/assets/javascripts/bootstrap/modal"
import Vue from "vue"
import SmoothScroll from "smooth-scroll"
import { debounce } from "lodash"
import ApplicationForm from "./vue/ApplicationForm.vue"
import ApplicationFormV2 from "./vue/ApplicationFormV2.vue"

if (document.querySelector("#formApp")) {
  // eslint-disable-next-line
  new Vue({
    el: "#formApp",
    components: { ApplicationForm, ApplicationFormV2 }
  })
}

$(".scroll-to-form").on("click", e => {
  e.preventDefault()

  const form = document.querySelector(".home-hero, .subpage-hero")

  new SmoothScroll().animateScroll(form)
})

$(".form-postcode").on("submit", e => {
  if (!e.target.dataset.postcodes || !e.target.elements.ppc) {
    return null
  }

  const patterns = JSON.parse(e.target.dataset.postcodes)
  const postcode = e.target.elements.postcode.value.replace(/\s/g, "")
  let withinArea = false

  patterns.forEach(pattern => {
    if (postcode.startsWith(pattern)) {
      withinArea = true
    }
  })

  if (!withinArea) {
    e.target.elements.ppc.disabled = true
  }

  return true
})

$(window).on(
  "scroll",
  debounce(() => {
    const $bar = $("section.sticky-bar")
    const isOnBottom =
      $(document).scrollTop() + $(window).height() >=
      $(document).height() - $(window).height() / 2
    const isOnTop = $(document).scrollTop() < $(window).height() / 2
    $bar.toggleClass("hide", isOnBottom || isOnTop)
  }, 50)
)
